module.exports = __webpack_public_path__ + "static/media/antigua-accommodation-12.1cf07121.jpg";